"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicModuleTypeToJSON = exports.LogicModuleTypeFromJSONTyped = exports.LogicModuleTypeFromJSON = exports.LogicModuleType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var LogicModuleType;
(function (LogicModuleType) {
    LogicModuleType["COUNTERGOAL"] = "COUNTER_GOAL";
    LogicModuleType["COUNTERPEREVENT"] = "COUNTER_PER_EVENT";
    LogicModuleType["STREAKEVENT"] = "STREAK_EVENT";
    LogicModuleType["STREAKTIME"] = "STREAK_TIME";
    LogicModuleType["NULLIFIER"] = "NULLIFIER";
})(LogicModuleType = exports.LogicModuleType || (exports.LogicModuleType = {}));
function LogicModuleTypeFromJSON(json) {
    return LogicModuleTypeFromJSONTyped(json, false);
}
exports.LogicModuleTypeFromJSON = LogicModuleTypeFromJSON;
function LogicModuleTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LogicModuleTypeFromJSONTyped = LogicModuleTypeFromJSONTyped;
function LogicModuleTypeToJSON(value) {
    return value;
}
exports.LogicModuleTypeToJSON = LogicModuleTypeToJSON;
